import { CommunicationTypeIcon } from '@/components/CommunicationTypeIcon';
import { getCommunicationDirectionLabel } from '@bariendo/lib/call-log';
import { Group, Text } from '@mantine/core';
import { Communication } from '@medplum/fhirtypes';
import { ReactElement } from 'react';

/**
 * The first cell of a Phone logs or SMS logs row: the type icon with `IN` / `OUT` beside it.
 *
 * Blank rather than a guess on a row that records no direction — see
 * `getCommunicationDirectionLabel`.
 */
export function CommunicationDirectionCell({ communication }: { communication: Communication }): ReactElement {
  const label = getCommunicationDirectionLabel(communication);
  return (
    <Group gap={6} wrap="nowrap" align="center">
      <CommunicationTypeIcon communication={communication} />
      <Text size="xs" fw={600} c="dimmed">
        {label ?? ''}
      </Text>
    </Group>
  );
}
